import { Chip, Tooltip } from '@mui/material';

import { IncidentStatus } from '../../api/incidentLog';
import { INCIDENT_STATUS_META } from '../../utils/incidentRekindle';

/** The incident's derived status as a coloured chip, with its meaning on
 *  hover. Same colour the map uses for the incident's hull and marker. */
export default function IncidentStatusChip({
    status,
    size = 'small',
}: {
    status: IncidentStatus;
    size?: 'small' | 'medium';
}) {
    const meta = INCIDENT_STATUS_META[status];
    if (!meta) return null;
    return (
        <Tooltip title={meta.description} placement="top">
            <Chip
                size={size}
                label={meta.label}
                sx={{
                    flexShrink: 0,
                    cursor: 'inherit',
                    fontWeight: 600,
                    color: meta.closed ? 'rgba(255,255,255,0.75)' : '#0f172a',
                    backgroundColor: meta.closed ? 'rgba(107,114,128,0.35)' : meta.color,
                    border: `1px solid ${meta.color}`,
                    '& .MuiChip-label': { fontSize: '0.72rem' },
                }}
            />
        </Tooltip>
    );
}
